import { Line } from 'app/hooks/useRulerTools';

/**
 * Calculates the angle between a line and the north direction
 *
 *
 * @param {Line} line - The line object containing source and target positions
 * @returns {number} - Angle in degrees between the line and north direction
 */

export function getBearing(line: Line) {
  const vectorLine = [line.targetPosition[0] - line.sourcePosition[0], line.targetPosition[1] - line.sourcePosition[1]];
  const vectorNorth = [0, 1];

  const magnitude1 = Math.sqrt(vectorLine[0] ** 2 + vectorLine[1] ** 2);
  const magnitude2 = Math.sqrt(vectorNorth[0] ** 2 + vectorNorth[1] ** 2);

  const unitVector1 = [vectorLine[0] / magnitude1, vectorLine[1] / magnitude1];
  const unitVector2 = [vectorNorth[0] / magnitude2, vectorNorth[1] / magnitude2];

  const dotProduct = unitVector1[0] * unitVector2[0] + unitVector1[1] * unitVector2[1];

  const angleAbsolut = Math.round((Math.acos(dotProduct) * 180) / Math.PI);

  const angle = vectorLine[0] < 0 ? 360 - angleAbsolut : angleAbsolut;
  return angle;
}
export function getBearingText(bearing?: number) {
  const res = typeof bearing === 'number' && !Number.isNaN(bearing) ? `${bearing}` + '\u00b0' : '';
  return res;
}
